/** C3/C6 — مصدر واحد لجداول صفحة المبيعات: ترتيب الأعمدة (الإجمالي ثم الفروع بترتيب /pos/branches)
 *  ونمط الحدود (قوي بين المقاييس والأعمدة وتحت الترويسة · خفيف بين صفوف المقارنة). ألوان الثيم فقط. */
import React, { createContext, useContext } from "react";

export const TOTAL_COL = { id: "total", name: "الإجمالي" };
export const BranchOrderContext = createContext([]);

export const orderBranches = (list, order, idKey = "branch_id") => {
  const idx = (b) => { const i = (order || []).indexOf(b?.[idKey]); return i < 0 ? Number.MAX_SAFE_INTEGER : i; };
  return [...(list || [])].map((b, i) => [b, i]).sort((a, c) => idx(a[0]) - idx(c[0]) || a[1] - c[1]).map(([b]) => b);
};
export const branchColumns = (list, order, idKey = "branch_id") =>
  [TOTAL_COL, ...orderBranches(list, order, idKey).map((b) => ({ ...b, id: b[idKey] || "none", name: b.branch_name || "بدون اسم" }))];
export const useBranchOrder = () => useContext(BranchOrderContext);

export const STRONG = "1px solid var(--border-strong)";
export const LIGHT = "1px solid var(--border)";
// G1 (2026-02) — قاعدة تصميم ثابتة لكل جداول صفحة المبيعات (الفروع ·
// العملاء · الجدول التفصيلي · الأكثر طلباً): عمود العنوان/الفترة عرض ثابت.
// P1 (2026-02) — عطل إنتاج: أعمدة البيانات كانت بعرض بكسلي *ثابت*
// (DATA_COL_WIDTH) بصرف النظر عن عرض البطاقة الحاوية — فإن كانت البطاقة
// أعرض من TITLE+PERIOD+DATA_COL_WIDTH×عدد الأعمدة (الحالة الشائعة على
// سطح المكتب بفرعين فقط) يبقى الجدول بعرضه البكسلي الصغير ونصف البطاقة
// فارغاً، كما أبلغ المالك. الإصلاح: الجدول width:100% دائماً (يملأ
// البطاقة)، وأعمدة البيانات بلا width صريح إطلاقاً — table-layout:fixed
// يوزّع العرض *المتبقي* (بعد العنوان/الفترة الثابتين) عليها بالتساوي
// تلقائياً (سلوك المتصفح القياسي لعمود بلا width تحت tableLayout:fixed) —
// لا حساب يدوي للعرض بعد الآن.
export const TITLE_COL_WIDTH = 170;
export const PERIOD_COL_WIDTH = 108;
// حدّ أدنى معقول لعمود بيانات واحد لقابلية القراءة (قيمة مالية + أيقونة
// رقم قياسي مُحتملة معاً) — يُستخدم فقط لحساب الحدّ الأدنى الكلي للجدول
// (minWidth أدناه)، لا لضبط عرض عمود فعلياً.
export const DATA_COL_MIN_WIDTH = 100;
export const TABLE = { borderCollapse: "collapse", minWidth: 0, tableLayout: "fixed", width: "100%" };

/** P1 — الحدّ الأدنى الكلي لعرض الجدول (minWidth، لا width): يملأ الجدول
 *  100% من عرض البطاقة إن اتّسعت (table-layout:fixed يوزّع البيانات
 *  بالتساوي)، ولا ينضغط دون هذا الحدّ على شاشة ضيّقة (الجوال) — فيظهر
 *  تمرير أفقي بدل أعمدة مضغوطة غير مقروءة (الحاوية overflowX:auto). */
export function salesTableMinWidth(dataCols, withPeriodCol = false) {
  return TITLE_COL_WIDTH + (withPeriodCol ? PERIOD_COL_WIDTH : 0) + DATA_COL_MIN_WIDTH * dataCols;
}

export const TH = { borderBottom: STRONG, borderInlineStart: STRONG, padding: "6px 8px" };
export const TD = (first) => ({ borderTop: first ? STRONG : LIGHT, borderInlineStart: STRONG, padding: "4px 8px" });

/** G1 — أول عنصر ثابت داخل <table> يفرض عرض الأعمدة فعلياً مع table-layout:fixed.
 *  withPeriodCol=true لجداول المقارنة (CompareTable: عنوان + فترة + بيانات)،
 *  false للجداول البسيطة (الأكثر طلباً/الجدول التفصيلي: عنوان + بيانات).
 *  P1 — أعمدة البيانات بلا <col width> إطلاقاً (تتقاسم العرض المتبقي بالتساوي). */
export function SalesColGroup({ dataCols, withPeriodCol = false }) {
  return (
    <colgroup>
      <col style={{ width: TITLE_COL_WIDTH }} />
      {withPeriodCol && <col style={{ width: PERIOD_COL_WIDTH }} />}
      {Array.from({ length: dataCols }).map((_, i) => <col key={i} />)}
    </colgroup>
  );
}
